import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-list-mode',
  templateUrl: './list-mode.component.html',
  styleUrls: ['./list-mode.component.scss']
})
export class ListModeComponent implements OnInit
{

  /**
   * Title key to use for the text.
   */
  @Input() public titleKey: string;

  /**
   * Unique storage key for saving the advance mode to local storage.
   */
  @Input() public storageKey: string;

  /**
   * Indicate the context mode being used: card or calendar
   */
  @Input() public contextMode = 'card';

  /**
   * Indicate the default mode to use
   */
  @Input() public defaultMode;

  /**
   * Event emitter when when switch changes
   */
  @Output() public collapsibleToggle = new EventEmitter<string>();

  /**
   * Track the view mode.
   */
  public viewMode: string;

  /**
   * Title label
   */

  public titleLabel = '';

  /**
   * Storage prefix
   */
  private storagePrefix = 'view-mode-';

  /**
   * Constructor
   */
  constructor(
    private storageService: LocalStorageService,
    private translate: TranslateService)
  {
  }

  public ngOnInit(): void
  {
    const viewMode = (this.storageKey !== '') ? this.storageService.retrieve(`${this.storagePrefix}${this.storageKey}`) : undefined;
    this.viewMode = (this.defaultMode !== undefined && !viewMode) ? this.defaultMode : viewMode || this.contextMode;
    this.collapsibleToggle.emit(this.viewMode);
    if (this.titleKey !== '')
    {
      this.translate.get(this.titleKey).subscribe({
        next: (value) =>
        {
          this.titleLabel = value + ':';
        }
      });
    }
  }

  /**
   * Event handler when the view has changed.
   *
   * @param newValue New view value.
   */
  public onChange(newValue: string): void
  {
    this.viewMode = newValue;
    this.storageService.store(`${this.storagePrefix}${this.storageKey}`, this.viewMode);
    this.collapsibleToggle.emit(this.viewMode);
  }

  /**
   * This method is being used to set the list mode value externally to the component.
   * This is being used in the program list context when saving filter.
   *
   * @param newValue Mode value
   */
  public setListModeValue(viewMode: string): void
  {
    this.viewMode = viewMode;
  }

}
